// src/components/ConnectionGuard.jsx
import React, { useEffect, useState } from "react";
import OfflineScreen from "./OfflineScreen";

const ConnectionGuard = ({ children }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return isOnline ? children : <OfflineScreen />;
};

export default ConnectionGuard;
